import datamethods from '../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../style/format.js'
export default{
    mixins:[datamethods,format],
    computed:{
      ...mapFields([
        'loggedInUser',
        'location',
        'logoImageBasePath',
        'logoOverride',
        'businessDayId',
        'terminalId',
        'pleaseWait',
        'responseMessage',
        'ticket',
        'LocationList',
        'terminalList',
        'locationAndTerminalPreselected',
        'cartItems',
        'cartItemsByGroup',
        'cartEligibleForFA',
        'panels',
        'availableCartItems',
        'availableCartItemTypes',
        'selectedCartItemType',
        'guest',
        'suspendedTicketCount',
        'guestList',
        'lookupString',
        'cartItemCount',
        'payTotal',
        'due',
        'change',
        'isCash',
        'inPayment',
        'isReturn',
        'isCompletable',
        'addingProduct',
        'scannedItems',
        'productString',
        'giftCardToAdd',
        'selectedGuid',
        'productToGetPrice',
        'productOptionList',
        'productToGetOptions',
        'guestAccounts',
        'username',
        'password',
        'processedCardTotal',
        'isExchange',
        'productString_toReturn',
        'productString_toPurchase',
        'scannedItems_toReturn',
        'scannedItems_toPurchase',
        'cartItems_toReturn',
        'cartItems_toPurchase',
        'lastLineItemIdAdded',
        'faBalance',
        

    ]),
      
      layout(){
          if(window.LAYOUT==undefined){return 'default'}
          else{return window.LAYOUT}
      },
      LogoPath(){
        if(this.logoOverride!=''){
            return this.logoImageBasePath + this.logoOverride
        }else{
            return './../' + window.SCHOOL_LOGO
        }
      },
      showOptInEmail(){
            if(window.SHOW_OPTIN_EMAIL==undefined){return false}
            else{return window.SHOW_OPTIN_EMAIL}
        },
        showOptInSMS(){
            if(window.SHOW_OPTIN_SMS==undefined){return false}
            else{return window.SHOW_OPTIN_SMS}
        },
      ShowSuspended(){
        if(window.SHOW_SUSPENDED==undefined){return false}
        else{return window.SHOW_SUSPENDED}
      },
      ShowTransactions(){
        if(window.SHOW_TRANSACTIONS==undefined){return false}
        else{return window.SHOW_TRANSACTIONS}
      },
      showAccount(){
        if(window.SHOW_ACCOUNT==undefined){return false}
        else{return window.SHOW_ACCOUNT}
      },
      showGiftcard(){
        if(window.SHOW_GIFTCARD==undefined){return false}
        else{return window.SHOW_GIFTCARD}
      },

      defaultGuestId(){
          
        if(window.DEFAULT_GUESTID==undefined){return 0}
        else{return window.DEFAULT_GUESTID}
      },
      showUpdateGuest: function() {
        return this.allowUpdateGuest && this.isValid;
      },
      showAddGuest(){
        
        if(window.SHOW_ADD_GUEST==undefined){return false}
        else{return window.SHOW_ADD_GUEST}
      },
      addGuestRequireStudentID(){
        
         if(window.ADD_GUEST_REQUIRE_STUDENTID==undefined){return 'True'}
        else{
          if(window.ADD_GUEST_REQUIRE_STUDENTID){
            return 'True'
          }else{return 'False'}
        }
      },
      showLookupGuest(){
        
        if(window.SHOW_GUEST_LOOKUP==undefined){return true}
        else{return window.SHOW_GUEST_LOOKUP}
      },
      AutoSelectGuestIfOneResult(){
        if(window.AUTO_SELECT_GUEST_IF_ONE_RESULT==undefined){return false}
        else{return window.AUTO_SELECT_GUEST_IF_ONE_RESULT}
      },
      productsByGuest(){
        if(window.SELECT_PRODUCTS_BY_GUEST==undefined){return false}
        else{return window.SELECT_PRODUCTS_BY_GUEST}
      },
      showAR(){
        
        if(window.SHOW_AR==undefined){return false}
        else{return window.SHOW_AR}
      },
      useProductGroups(){
        if(window.USE_PRODUCT_GROUPS==undefined){
          return false
        }else{return window.USE_PRODUCT_GROUPS}
      },
      AutoAddProduct(){
        if(window.AUTO_ADD_PRODUCT==undefined){return false}
        else{return window.AUTO_ADD_PRODUCT}
      },
      AutoAddProductStudentOnly(){
        if(window.AUTO_ADD_PRODUCT_STUDENT_ONLY==undefined){return false}
        else{return window.AUTO_ADD_PRODUCT_STUDENT_ONLY}
      },
      AskInventoryForReturn(){
        
        if(window.ASK_INVENTORY_FOR_RETURN==undefined){return false}
        else{return window.ASK_INVENTORY_FOR_RETURN}
      },
      
      InventoryReasonForRefund(){
        
        if(window.INVENTORY_REASON_FOR_REFUND==undefined){return false}
        else{return window.INVENTORY_REASON_FOR_REFUND}
      },
      AutoStartOver(){
        
        if(window.AUTO_START_OVER==undefined){return false}
        else{return window.AUTO_START_OVER}
      },
      ShowAdminDiscount(){
        if(window.SHOW_ADMIN_DISCOUNT==undefined){return false}
        else{return window.SHOW_ADMIN_DISCOUNT}
      },
      showFinancialAid(){
        if(window.SHOW_FINANCIALAID==undefined){return false}
        else{return window.SHOW_FINANCIALAID}
      },
      
      AutoAddScannedProduct(){
        if(window.AUTO_ADD_SCANNED_PRODUCT==undefined){return false}
        else{return window.AUTO_ADD_SCANNED_PRODUCT}
      },
      showReturn(){
        if(window.SHOW_RETURN==undefined){return false}
        else{return window.SHOW_RETURN}
      },
      
      showTaxExempt(){
        if(window.SHOW_TAX_EXEMPT==undefined){return false}
        else{return window.SHOW_TAX_EXEMPT}
      },
      
      receiptTextAvailable(){
        if(window.RECEIPT_TEXT_AVAILABLE==undefined){return false}
        else{return window.RECEIPT_TEXT_AVAILABLE}
      },
      
      startGuestTicketIsGuestLookup(){
        if(window.START_GUEST_TICKET_IS_GUEST_LOOKUP==undefined){return false}
        else{return window.START_GUEST_TICKET_IS_GUEST_LOOKUP}
      },
    },
    methods:{
      logout(){
        this.username=null
        this.password=null
        this.loggedIn=false
      },
      getSuspendString(){
        return 'Do you want to suspend this ticket?'
      },
      async getLocations(){
            
        //call api
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(null,'locations_posonly')
        //handle response
    
        if(response.Successful){
          
          this.LocationList= response.locationList
          if(this.LocationList.length>0){
            if(this.location.id==-1){
              this.location.id = this.LocationList[0].id
              this.location.name=this.LocationList[0].name
              
            }else{
              this.locationAndTerminalPreselected=true
            }
            this.selectLocation()
          }

        }else{
          this.responseMessage = response.Message
        }
        this.pleaseWait=false;
      },
      selectLocation(){
        
        var locid= this.location.id
        var max=0;
        for(var i = 0; i<this.LocationList.length;i++){
          if (this.LocationList[i].id==locid){
            max=this.LocationList[i].maxTerminalId
            this.location.name=this.LocationList[i].name
          }
        }
        this.location.maxTerminalId=max

        this.getTerminalList()
        this.selLocation()
      },
      getTerminalList(){
       
        //based on selected location
        var max = this.location.maxTerminalId
        if (max==0){
          this.terminalList=[];
          return;
        }
   
        var tlist=[max];
        for(var i = 0; i<max;i++){
          tlist[i]={id:i+1, name:'Terminal ' + (i+1)}
          
        }
       this.terminalList=tlist
       
      },
      selLocation(){
    
        this.getBusinessDay();
        if(window.SELECT_PRODUCTS_BY_GUEST){
          //wait...we'll get products once we get a guest
        }
        else if(window.USE_PRODUCT_GROUPS){
          this.getAvailableGroups();
        }else{
          this.getAvailableItemTypes();
          this.getAvailableItems();
        }
        
        
      },
      async getBusinessDay(){
       
        let req = {
            locationId:this.location.id,
            terminalId:this.terminalId
        }  
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'businessday')
          //handle response
      
          if(response.Successful){
            this.businessDayId=response.ResponseInteger
            if (this.businessDayId==-1){
              this.responseMessage = "This Location is NOT open"
            }else{this.responseMessage="OPEN!"}

            this.getsuspendedticketcount()
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
       
      gototicket(ticketId, gotoguest=false){
       console.log('ticket ' + ticketId)
        this.ticket.id=ticketId
        this.isGoTo=true
        this.refreshticket(false,null,gotoguest)
      },
      async refreshticket(start,msg,gotoguest=false){
        console.log('in refresh ticket')
        await this.getticket()

           //start cart!
           if(start){
            this.addingProduct=false 
             this.startCart()
            
           }else if (this.isGoTo){
             this.isGoTo=false
          
              await this.$store.dispatch('buildCart');
              this.refreshCart()
              this.updatePayTotals_pos()
              //this.refreshticket()
              this.refreshGuest()

              //decide which tab to go to
              if(gotoguest){
                this.$store.dispatch('setActivePanel',0); 
              }
             else if(this.payItems.length>0 ){
                this.$store.dispatch('setActivePanel',2); 
              }else{
                this.$store.dispatch('setActivePanel',1); 
              }
              this.addingProduct=false 
            }else{
              this.$store.dispatch('buildCart');
             this.refreshCart()
             this.updatePayTotals_pos()
             this.addingProduct=false //moved from the return part of addticketlineitem to make sure we have the data
             //this.$refs.pay.updateTotals()
           }
           if (msg!=null){this.responseMessage=msg}
     },
     updatePayTotals_pos(autoreceipt=false, refresh=false){
      
        this.responseMessage=null
        var i;
        var total = 0;
        this.haveUnprocessedCard=false;
        this.processedCardTotal=0
        console.log('update pay total -pos ')
        if(this.payItems!=null){
          for (i = 0; i <= this.payItems.length - 1; i++) {

            total = this.addmoney(total, this.payItems[i].price)
            if(this.payItems[i].name.toLowerCase()=='cash'){
              this.isCash=true
            }
            if(this.payItems[i].name.toLowerCase()=='card' && this.payItems[i].authorizationCode==null){
              this.haveUnprocessedCard=true

            }else if(this.payItems[i].name.toLowerCase()=='card' && this.payItems[i].authorizationCode!=null){
              this.processedCardTotal=this.processedCardTotal+this.payItems[i].price
            }
          }
        }
          

          this.payTotal = total//.toFixed(2);
          //console.log('update pay total2 ' + this.payTotal)
  
          this.due = this.subtractmoney(this.ticket.total,this.payTotal)
          //console.log('set due ' + this.ticket.total + ' ' + this.payTotal + ' ' + this.due)
  
  
  
          //account for change

          if(this.due<0 && this.isCash==true){
            this.change=this.due * -1;
            this.due=0
          }else{
            this.change=0
          }
       
          var amt = this.$options.filters.toCurrency(this.ticket.total);
          this.panels[2].title = 'Payment: ' + amt ;
          if(this.due==0){
            this.panels[2].valid = true;
            this.panels[3].available = true;
  
            //go ahead and get receipt data if we need it
            if(this.receiptIP!='ip'){
              //this.getReceiptData(autoreceipt)
            }
          }else{
            this.panels[2].valid = false;
            this.panels[3].available = false;
          }
          //this.$emit('refreshticket')
          if(refresh){this.refreshticket()}
      },
      async getticket(){
        console.log('getticket ' + this.ticket.id)
        let req = {
          ticket:{
            id:this.ticket.id
          }
        }  
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'ticket')
          //handle response
      
          if(response.Successful){
            this.ticket=response.ticket

            
           
            
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },

      //cart
      async startCart(){
        console.log('instartcart')
        this.productString=''
        this.scannedItems=[]
        await this.refreshCart(); //so it refreshes what we see
        this.updatePayTotals_pos()
        //this.$store.dispatch('startOver_Cart');
        if(this.AutoAddProduct){
          if(this.AutoAddProductStudentOnly==false ||this.guest.isStudent==true ){
            this.GetDefaultProduct()
          }
          
          
        }
        this.getProductsByGroup()
      },
      async refreshCart(){
     
        var i;
        var total = 0;
        var count = 0;
        var tax = 0; //get from db
        var faEligible=this.cartItems.length>0 && this.showFinancialAid;
  

          for (i = 0; i < this.cartItems.length ; i++) {
            //total = total + (Number(this.cartItems[i].price) * Number(this.cartItems[i].quantity));
            var amt =Number(this.cartItems[i].price) * Number(this.cartItems[i].quantity)
            total = this.addmoney(total, amt)
            count = count + Math.abs(Number(this.cartItems[i].quantity))
            if(this.showFinancialAid){
              if(this.cartItems[i].isFinancialAidEligible==false){faEligible=false}
            }
            
          }

          //set fa eligible flag
          this.cartEligibleForFA=faEligible 
          //this.cartSubTotal=total;
          //this.cartTax=tax;
          //this.cartTotal = total + tax;
          this.cartItemCount = count;

          /* if(this.isExchange){
            this.cartItemCount = this.cartItems_toReturn.length + this.cartItems_toPurchase.length
            console.log('exch update cart item count ' + this.cartItemCount)
          } */

          console.log('in refresh cart ' + this.payTotal)
          this.due = this.subtractmoney(this.ticket.total,this.payTotal)
  
          //account for change
          if(this.due<0 && this.isCash==true){
            this.change=this.due * -1;
            this.due=0
          }
  
          //var amt = this.$options.filters.toCurrency(this.cartTotal);
          var amt = this.$options.filters.toCurrency(this.ticket.total);
          this.panels[1].title = 'Cart: ' + amt + ' (' + this.cartItemCount + ')';
  
          if(this.cartItemCount!=0){
            this.panels[1].valid = true;
            if(this.ticket.total!=0){
              this.panels[2].available = true;
            }else{
              this.panels[3].available = true;
            }
            
            
          }else{
            this.panels[1].valid = false;
            this.panels[2].available = false;
          }
  
          

          this.isCompletable = this.panels[2].available && this.panels[1].valid && this.cartItemCount>0  && this.due==0
      },
      addCartItem(cartItemID) {
      
        var i;
        for (i = 0; i <= this.availableCartItems.length - 1; i++) {
          if (this.availableCartItems[i].id == cartItemID) {
              this.addSelectedItem(this.availableCartItems[i])
          }
        }
    },
    addGroupCartItem(cartItemID){
   
      var i;
        for (i = 0; i <= this.cartItemsByGroup.length - 1; i++) {
          if (this.cartItemsByGroup[i].id == cartItemID) {
              this.addSelectedItem(this.cartItemsByGroup[i])
          }
        }
    },
    addScannedItem(cartItemID) {
      
        var i;
        for (i = 0; i <= this.scannedItems.length - 1; i++) {
          if (this.scannedItems[i].id == cartItemID) {
              this.addSelectedItem(this.scannedItems[i])
          }
        }
    },
    addSelectedItem(cartItem,isauto) {
        console.log('addsel')
        var cartItemID = cartItem.id
        var newItem;
        var i;
        var j;
 
        //see if item already in cart, if so, incr qty
        var found=false;
        for (j = 0; j <= this.cartItems.length - 1; j++) {
          if (this.cartItems[j].id == cartItemID) {

            //exception for gc.  don't mark it found
            if((cartItem.isPurchaseGiftCard || cartItem.isAddValueGiftCard) && cartItem.giftCardNumber==null){
              //nope!
            }
            else{
              found=true;
    
              if(this.isReturn){
                this.cartItems[j].quantity=Number(this.cartItems[j].quantity) - 1
              }else{
                this.cartItems[j].quantity=Number(this.cartItems[j].quantity) + 1
              }
              
              this.updateQuantity(this.cartItems[j])

              //force update of quantity on the ui
              this.panels[this.panelIndex].active=false;
              this.$nextTick(() => {
                this.panels[this.panelIndex].active=true;
              });
            }

            
          }
        }
        //add anew one
        
        if(!found){
          newItem = cartItem;
          newItem.quantity=1
          newItem.isAuto=isauto
          console.log('addsel  ' + found)
          this.addProductItemToData(newItem)
          
        }else{
          
        }
        
        
    },
    updateitemquantity(cartItem, qty){
      cartItem.quantity=qty
      this.updateQuantity(cartItem)
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async removelineitem(cartItemID){
      this.responseMessage=null
      await this.sleep(500);//pause
      //first check. if we have processed pmts, and taking this out puts us below that amt..nope
        if(this.processedCardTotal>0){
          var thisItemAmt = 0
          console.log('checking if ok to remove line item')
          var i;
          for (i = 0; i <= this.cartItems.length - 1; i++) {
            if (this.cartItems[i].id == cartItemID) {
                thisItemAmt=this.cartItems[i].price
                break; //only take this one
            }
          }  
          var cartWithoutThisItem = this.ticket.total - thisItemAmt
          console.log(cartWithoutThisItem + ' ' + this.ticket.total + ' ' + thisItemAmt)
          if(cartWithoutThisItem < this.processedCardTotal){
            
                this.responseMessage="The payment for this item has already been processed. You may not remove it, unless you add another product first."
                
             
            return //no remove
          }
        }

      var i;
        for (i = 0; i <= this.cartItems.length - 1; i++) {
          if (this.cartItems[i].id == cartItemID) {
            this.removeLineItemFromData(this.cartItems[i])
              this.cartItems.splice(i,1)
              
              break; //only take this one
          }
        }  
    },
    async removelineitem_exchange(lineItemId, lineItemId_Exchange){
      console.log('remove exch ' + lineItemId + ' ' + lineItemId_Exchange)
      this.responseMessage=null
      await this.sleep(500);//pause
      
      var i;
      //first 
        for (i = 0; i <= this.cartItems.length - 1; i++) {
          if (this.cartItems[i].lineItemId == lineItemId  ) {
            await this.removeLineItemFromData(this.cartItems[i],false)//don't allow refresh after the first one
              this.cartItems.splice(i,1)
          }
        }  

        //second and allow refresh
        for (i = 0; i <= this.cartItems.length - 1; i++) {
          if (this.cartItems[i].lineItemId == lineItemId_Exchange  ) {
            await this.removeLineItemFromData(this.cartItems[i])
              this.cartItems.splice(i,1)
          }
        }  
    },
    cartItemIsExchange(cartItem){
      console.log('exc ' + cartItem.ticketLineItemId_Exchange)
      if(cartItem.ticketLineItemId_Exchange==null){return false}
      
     if(cartItem.ticketLineItemId_Exchange==0){return false}
      if(cartItem.ticketLineItemId_Exchange=='0'){return false}

      return true
          

    },
    async addProductItemToData(item,isReturnFromExchange=false,isInventoryReturn=true){
      console.log('addpitemtodata ' + isInventoryReturn)
      if(this.addingProduct){return}
      

      //handle gift cards
      if((item.isPurchaseGiftCard || item.isAddValueGiftCard) && item.giftCardNumber==null){
        //go do gift things first
        this.getGiftInfo(item)
        return;
      }

      //handle variable price items
      if((item.isVariablePrice && item.price==0)){
        this.getPrice(item)
        return;
      }

      //handle options
      
        console.log('item ' + item.hasProductOptions + ' ' + item.selectedProductOptions)
        if(item.hasProductOptions && item.selectedProductOptions==null){
          this.getOptions(item)
          return
        }
      
      


      this.addingProduct=true

      let req = {
            ticketId:this.ticket.id,
            productCode:item.code,
            productId:item.id,
            price:item.price,
            locationId:this.ticket.locationId,
            businessDayId:this.ticket.businessDayId,
            personId:this.ticket.guestId,
           giftCardNumber:item.giftCardNumber,
           isGiftCard:item.isGiftCard,
           selectedProductOptions:item.selectedProductOptions,
           productOptionsString:item.productOptionsString
        }

        //call api
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'addticketlineitem')
        //handle response
     
        if(response.Successful){
           item.lineItemId=response.ResponseInteger
           this.lastLineItemIdAdded=response.ResponseInteger//stash this!
           this.cartItems.push(item);

           //clear gc
           //******this.addingProduct=false
           this.giftCardToAdd={}
           
          //if auto add, clear scanned items
          if(this.AutoAddScannedProduct && this.scannedItems.length==1){
            this.scannedItems=[]
          }

          //if this is a return, call that before refreshing
          if(this.isReturn){this.returnitem(item.lineItemId,true)}
          if(isReturnFromExchange){await this.returnitem(item.lineItemId,true,isInventoryReturn)}

           this.updateTotals()
        }else{
          this.responseMessage = response.Message
          this.addingProduct=false
        }
        this.pleaseWait=false;
    },
    async removeLineItemFromData(item, okToUpdateTotals=true){
      let req = {
          ticketLineItem:{
            id:item.lineItemId
          }
        }
        //call api
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'removeticketlineitem')
        //handle response
     
        if(response.Successful){
            if(okToUpdateTotals){this.updateTotals();}
        }else{
          this.responseMessage = response.Message
        }
        this.pleaseWait=false;
    },

      //product
      async getAvailableItemTypes(){
        let req = {
          locationId:this.location.id
      }  
        //call api
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'producttype')
        //handle response
    
        if(response.Successful){
          
          let tmpItems= response.productTypeList
          
          if (tmpItems == undefined) {
            let noneItem = dataModel.NoItemsItem();
            this.availableCartItemTypes.push(noneItem);
          } else {
            this.availableCartItemTypes = tmpItems;
          }
          if(this.availableCartItemTypes.length>0){
            this.selectedCartItemType=this.availableCartItemTypes[0].id
            this.availableCartItemTypes[0].selected=true
          }else{this.selectedCartItemType=0}
        }else{
          this.responseMessage = response.Message
        }
        this.pleaseWait=false;
    },
    async getAvailableItems(){
      let req = {
          locationId:this.location.id
      }      
      //call api
      this.$store.dispatch('beforeAPI');
      var response = await this.callAPI(req,'product')
      //handle response
   
      if(response.Successful){
        
        let tmpItems= response.productList
         
        if (tmpItems == undefined) {
          let noneItem = dataModel.NoItemsItem();
          this.availableCartItems.push(noneItem);
        } else {
          this.availableCartItems = tmpItems;
        }

    
      }else{
        this.responseMessage = response.Message
      }
      this.pleaseWait=false;
    },
    async getAvailableGroups(){

      let req = {
          locationId:this.location.id
      }  
        //call api
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'productgroup')
        //handle response
    
        if(response.Successful){
          
          let tmpItems= response.ProductGroupList
          
          if (tmpItems == undefined) {
            let noneItem = dataModel.NoItemsItem();
            this.availableCartItemTypes.push(noneItem);
          } else {
            this.availableCartItemTypes = tmpItems;
          }
          if(this.availableCartItemTypes.length>0){
            this.selectedCartItemType=this.availableCartItemTypes[0].id
            this.availableCartItemTypes[0].selected=true
          }else{this.selectedCartItemType=0}
        }else{
          this.responseMessage = response.Message
        }
        this.pleaseWait=false;
    },
    filterCartItems(){
      if(window.SELECT_PRODUCTS_BY_GUEST){
        return this.availableCartItems
      }

        var id=this.selectedCartItemType
        let temp = this.availableCartItems;
        if(temp!=undefined){
            temp = temp.filter((item)=>{
                return (item.typeId==id)
            })
        }
        
        return temp

             
    },
      async GetDefaultProduct(){
        
        let req = {
              locationId:this.ticket.locationId
            
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'defaultproduct_bytime')
          //handle response
       
          if(response.Successful){
            if(response.productList==null){return -1}

            
            if(response.productList.length==0){return -1}
             var productId=response.productList[0].id

             this.scannedItems=[]
              let req = {
                  
                  productId:productId
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'productlookup')
                //handle response
            
                if(response.Successful){
                  if(response.productList.length>0){
                    this.addSelectedItem(response.productList[0],true)
                  }
                  
                }else{
                  this.responseMessage = response.Message
                }
                this.pleaseWait=false;
          }else{
            //this.responseMessage = response.Message
            return -1
            
          }
          this.pleaseWait=false;
      },
      setType(cartitem){
      
        this.selectedCartItemType=cartitem.id
        this.selectedGuid = cartitem.guid
        var i;
        for (i = 0; i <= this.availableCartItemTypes.length - 1; i++) {
            if (this.availableCartItemTypes[i].id == cartitem.id) {
                this.availableCartItemTypes[i].selected=true
            }else{this.availableCartItemTypes[i].selected=false}
          }
          if(window.SELECT_PRODUCTS_BY_GUEST){
            this.getProductsByType()
          }else{
            this.getProductsByGroup()
          }
        
      },
      async getProductsByGroup(){
          let req = {
              locationId:this.ticket.locationId,
              productGroupId:this.selectedCartItemType
          }
            this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'products_bygroup')
          //handle response
          if(response.Successful){
                this.cartItemsByGroup=response.productList
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      async getProductsByType(){
        let req = {
            productTypeGUID:this.selectedGuid,
            locationId:this.guestLocationId
          }      
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'products')
          //handle response
       
          if(response.Successful){
            
            let tmpItems= response.productList
             
            if (tmpItems == undefined) {
              let noneItem = dataModel.NoItemsItem();
              this.availableCartItems.push(noneItem);
            } else {
              this.availableCartItems = tmpItems;
            }
  
        
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      async lookupProduct(){
        if(this.productString==null){return}
        if(this.productString==''){return}

        this.scannedItems=[]
        this.lookupmessage=null
        let req = {
            locationId:this.ticket.locationId,
            lookupString:this.productString
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'productlookup')
          //handle response
       
          if(response.Successful){
             this.scannedItems=response.productList
  
            //auto add
            if(this.AutoAddScannedProduct){
              if(this.scannedItems.length==1){
                this.addScannedItem(this.scannedItems[0].id)
                this.productString=null
                
              }
            }
            if(this.scannedItems.length==0){this.lookupmessage="No Products Found"}
  
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },

      //for exchange
      async lookupProduct_toReturn(){
        if(this.productString_toReturn==null){return}
        if(this.productString_toReturn==''){return}

        this.scannedItems_toReturn=[]
        let req = {
            locationId:this.ticket.locationId,
            lookupString:this.productString_toReturn
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'productlookup')
          //handle response
       
          if(response.Successful){
             this.scannedItems_toReturn=response.productList
            
              if(this.scannedItems_toReturn.length==1){
                this.addScannedItem_toReturn(this.scannedItems_toReturn[0].id)
                this.productString_toReturn=null
                
              }
  
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      async lookupProduct_toPurchase(){
        if(this.productString_toPurchase==null){return}
        if(this.productString_toPurchase==''){return}

        this.scannedItems_toPurchase=[]
        let req = {
            locationId:this.ticket.locationId,
            lookupString:this.productString_toPurchase
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'productlookup')
          //handle response
       
          if(response.Successful){
             this.scannedItems_toPurchase=response.productList
  
            if(this.scannedItems_toPurchase.length==1){
                this.addScannedItem_toPurchase(this.scannedItems_toPurchase[0].id)
                this.productString_toPurchase=null
                
              }
  
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      addScannedItem(cartItemID) {
      
        var i;
        for (i = 0; i <= this.scannedItems.length - 1; i++) {
          if (this.scannedItems[i].id == cartItemID) {
              this.addSelectedItem(this.scannedItems[i])
          }
        }
    },
    addScannedItem_toReturn(cartItemID) {
      
        var i;
        for (i = 0; i <= this.scannedItems_toReturn.length - 1; i++) {
          if (this.scannedItems_toReturn[i].id == cartItemID) {
              this.addSelectedItem_toReturn(this.scannedItems_toReturn[i])
          }
        }
        
    },
    addScannedItem_toPurchase(cartItemID) {
      
        var i;
        for (i = 0; i <= this.scannedItems_toPurchase.length - 1; i++) {
          if (this.scannedItems_toPurchase[i].id == cartItemID) {
              this.addSelectedItem_toPurchase(this.scannedItems_toPurchase[i])
          }
        }
        
    },
    addSelectedItem_toReturn(cartItem,isauto) {
        console.log('addsel')
        this.cartItems_toReturn=[]
        var cartItemID = cartItem.id
        var newItem;
        var i;
        var j;
        cartItem.unitPrice = cartItem.price
        this.cartItems_toReturn.push(cartItem);
        this.scannedItems_toReturn=[]
    },
    addSelectedItem_toPurchase(cartItem,isauto) {
        console.log('addsel')
        this.cartItems_toPurchase=[]
        var cartItemID = cartItem.id
        var newItem;
        var i;
        var j;
        cartItem.unitPrice = cartItem.price
        this.cartItems_toPurchase.push(cartItem);
        this.scannedItems_toPurchase=[]
    },
    async saveExchangeItems(isInventoryReturn,reason){
        console.log('saveexch ' + isInventoryReturn)
          var newItem = this.cartItems_toReturn[0];
          newItem.quantity=-1
          newItem.isAuto=false
          
          await this.addProductItemToData(newItem,true,isInventoryReturn) //tell it this is the return one

          var itemtoreturn = this.lastLineItemIdAdded

          //reset flag so exc goes through
          this.addingProduct=false
          var newItem2 = this.cartItems_toPurchase[0];
          newItem2.quantity=1
          newItem2.isAuto=false
          await this.addProductItemToData(newItem2)

          var itemtopurchase = this.lastLineItemIdAdded

   

          //call to associate them
          let req = {
            ticketLineItem:{
              id:itemtoreturn,
              ticketLineItemId_Exchange:itemtopurchase
            }
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'updateticketlineitem_exchange')
          //handle response
       
          if(response.Successful){

            //update local data
            console.log('exch ' + itemtoreturn + ' ' + itemtopurchase)
             this.cartItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let ci=arr[index]
                    if(ci.lineItemId==itemtoreturn ){
                        ci.ticketLineItemId_Exchange=itemtopurchase
                    }else if(ci.lineItemId==itemtopurchase ){
                      ci.ticketLineItemId_Exchange=itemtoreturn
                    }
                } 
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;


    },

      //gift 
      getGiftInfo(item){
        //create new object, so we aren't editing the real item
        this.giftCardToAdd={
          code:item.code,
          price:item.price,
          giftCardNumber:null,
          name:item.name,
          quantity:item.quantity,
          isFinancialAidEligible:item.isFinancialAidEligible,
          isGiftCard:true
        }
        this.$refs.giftcard.startAdd()
      },
     
      saveGiftCard(amount, number){
        this.giftCardToAdd.price=amount
        this.giftCardToAdd.giftCardNumber = number
        this.addProductItemToData(this.giftCardToAdd)
      },
      
      //product options
      async getOptions(item){
        this.productToGetOptions={
              code:item.code,
              price:item.price,
              minimumUnitPrice:item.minimumUnitPrice,
              name:item.name,
              quantity:item.quantity,
              isFinancialAidEligible:item.isFinancialAidEligible,
              selectedProductOptions:item.selectedProductOptions
            }
        let req = {
            ID:item.id
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'productoptions')
          //handle response
       
          if(response.Successful){
  
            this.productOptionList = response.productOptionList
            

            this.$refs.productOptions.Show(this.productOptionList)
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      saveProductWithOptions(options){
        this.productToGetOptions.selectedProductOptions=options
        this.addProductItemToData(this.productToGetOptions)
      },

      async saveOptions(options,lineitemid){
   
            //find the lineitem to add the options to
            this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.id==lineitemid ){
                        li.selectedProductOptions=options
                    }
                } 
           console.log('inpay=true saveoptions')       
          this.inPayment=true
          let req = {
              ticket:this.ticket,
              updatedLineItemId:lineitemid
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateticketlineitem_options')
            //handle response
            console.log('successful update options')
            if(response.Successful){
              this.inPayment=false
              console.log('successful update options2')
              //this.$nextTick(() => {
                this.refreshticket(false)
              //})
            }else{
              this.responseMessage = response.Message
            }
            this.inPayment=false
            this.pleaseWait=false;
        },

      //totals/refres
      updateTotals(){
        this.refreshticket()
      },

      //variable price
      getPrice(item){
        //variable price produt
        this.productToGetPrice={
          code:item.code,
          price:item.price,
          minimumUnitPrice:item.minimumUnitPrice,
          name:item.name,
          quantity:item.quantity,
          isFinancialAidEligible:item.isFinancialAidEligible,
        }
        this.$refs.setprice.start()
      },
      saveProductWithVariablePrice(price){
        this.productToGetPrice.price=price
        this.addProductItemToData(this.productToGetPrice)
      },

      //quantity
      async updateQuantity(item){
 
        let req = {
            ticketLineItem:{
              id:item.lineItemId,
              productId:item.id,
              quantity:item.quantity,
              unitPrice:item.unitPrice,
              ticketId:this.ticket.id
            },
            personId:this.ticket.guestId,
            businessDayId:this.ticket.businessDayId,
            locationId:this.ticket.locationId,
            ticketLineItemDiscounts:this.ticket.lineItemDiscounts
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'updateticketlineitem_quantity')
          //handle response
       
          if(response.Successful){
  
            //if auto add, clear scanned items
            if(this.AutoAddScannedProduct && this.scannedItems.length==1){
              this.scannedItems=[]
            }
  
             this.updateTotals();
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },

      //returns
      startreturn(){
        this.isReturn=true
        //if any items, call return on them. if its a free item, remove it
        var i;
        for (i = 0; i <= this.cartItems.length - 1; i++) {
          var islast = i==this.cartItems.length-1
          if(this.cartItems[i].price==0){
            this.removeforreturn(this.cartItems[i].lineItemId,islast)
          }else{
            this.returnitem(this.cartItems[i].lineItemId,islast)
          }
          
        }
      },
      async returnitem(id, islast=false,isInventoryReturn=true){
        console.log('return item ' + isInventoryReturn)
        let req = {
            ticketLineItem:{
              id:id
              
            },
            isRefund_NoInventory:!isInventoryReturn
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'refundticketlineitem')
          //handle response
       
          if(response.Successful){
            this.lastLineItemIdAdded=response.ResponseInteger//stash this!
             if(islast){this.refresh()}
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      async removeforreturn(id, islast=false){
        
        let req = {
            ticketLineItem:{
              id:id
            }
          }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'removeticketlineitem')
          //handle response
       
          if(response.Successful){
            if(islast){this.refresh()}
          }else{
            this.responseMessage = response.Message
          }
          this.pleaseWait=false;
      },
      
      //exchange
     startexchange(){
      this.isExchange=true
     },

      //***GUEST*** */
      selectDefaultGuest(){
        var defaultguest = {id:this.defaultGuestId, name:'Guest'}
        this.selectGuest(defaultguest)
       },
       async autoLookupGuest(){
        //trigger auto lookup of "guest"
        this.lookupString="guest"
        this.lookupGuest()
       },
        async lookupGuest(){
            this.selLocation() //check to see if we are open
            let req = {
              lookupString:this.lookupString
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'lookupguest')
            //handle response
         
            if(response.Successful){
              //reset flag
              this.inSelectGuest=false
              
              this.guestList= response.GuestList
              if(this.guestList.length==0){
                if(this.businessDayId!=-1){this.responseMessage="No Guests Found"}
              }
              //autoselect?
              if(this.AutoSelectGuestIfOneResult){
                if(this.guestList.length==1){
                  this.selectGuest(this.guestList[0])
                }
              }
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          guestclass(g){
            let c = "guestdetails panel-inner"
            if(this.isSelected(g)){
              c=c+" color-highlight"
            }else{c=c+" color-inner"}
            return c
          },
          showUpdate(g){
            return this.isSelected(g) && this.showUpdateGuest
          },
          async selectGuest(g){
            //if we are already selecting someone...dont' do another one
            if(this.inSelectGuest){return}
    
            this.inSelectGuest=true //set flag
    
            this.guest=g
    
            //this.AddTicket();
            //this.GetGuestAccount();
    
            //  SELECT
            this.panels[0].valid = true;
            this.panels[1].available = true;
            
            this.panels[0].title =  this.guest.name ;
            //this.guestText + ': ' +
    
            this.GetGuestAccount();
            this.GetGuestFinancialAid();
            if(this.productsByGuest){this.getProductsByGuest()}
            if(this.showAR){this.getARPaymentSubTypeByGuest()}
            //this.toNext()
          },
          refreshGuest(){
            console.log('in refresh guest')
            this.GetGuestAccount(false);
            this.GetGuestFinancialAid();
    
            if(this.productsByGuest){this.getProductsByGuest()}
          },
          async getProductsByGuest(){
            if(window.USE_PRODUCT_GROUPS){
              this.getGroupsByGuest()
              return;
            }
            let req = {
                    id:this.guest.id,
                }
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'producttypesbyguest')
    
                //handle response
                if(response.Successful){
                  let tmpItems= response.productTypeList
                  this.guestLocationId = response.locationId
                  
                  if (tmpItems == undefined) {
                    let noneItem = dataModel.NoItemsItem();
                    this.availableCartItemTypes.push(noneItem);
                  } else {
                    this.availableCartItemTypes = tmpItems;
                  }
                  if(this.availableCartItemTypes.length>0){
                    this.selectedCartItemType=this.availableCartItemTypes[0].id
                    this.availableCartItemTypes[0].selected=true
                  }else{this.selectedCartItemType=0}
                  //if(this.itemList.length==1){
                      //select the type to skip it
                  
                      //this.select(this.itemList[0].guid)
                      
                  //}
                }else{
                  this.responseMessage = response.Message
                }
                this.pleaseWait=false;
          
          },
          async getARPaymentSubTypeByGuest(){
            //clear
            this.arPaymentItemSubtypes = []
           
            let req = {
                ID:this.guest.id,
            }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'subtypebyguest')
              //handle response
          
              if(response.Successful){
                this.arPaymentItemSubtypes = response.ValueList
                //this.ARPaymentItemSubtypeId = response.LocationPOS.ticketPaymentItemSubtypeId_AR
                //this.ARPaymentItemSubtypeName = response.LocationPOS.ticketPaymentItemSubtypeName
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
          },
          async getGroupsByGuest(){
            let req = {
                id:this.guest.id,
            }  
              //call api
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'productgroupbyguest')
              //handle response
          
              if(response.Successful){
                
                let tmpItems= response.ProductGroupList
                
                if (tmpItems == undefined) {
                  let noneItem = dataModel.NoItemsItem();
                  this.availableCartItemTypes.push(noneItem);
                } else {
                  this.availableCartItemTypes = tmpItems;
                }
                if(this.availableCartItemTypes.length>0){
                  this.selectedCartItemType=this.availableCartItemTypes[0].id
                  this.availableCartItemTypes[0].selected=true
                }else{this.selectedCartItemType=0}
              }else{
                this.responseMessage = response.Message
              }
              this.pleaseWait=false;
          
          },
          async AddTicket(){
            let req = {
              ticket:{
                guestId:this.guest.id,
                businessDayId:this.businessDayId,
                locationId:this.location.id,
                terminalId:this.terminalId,
                employeeId:this.loggedInUser.user_personId
              }
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addticket')
            //handle response
         
            if(response.Successful){
              this.inSelectGuest=false //turn off flag
    
              this.ticket.id=response.ResponseInteger
              this.toNext();//
              this.$store.dispatch('startOver_Cart');
    
              this.$nextTick(() => {
                this.refreshticket(true)
              })
              
              
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async GetGuestAccount(createticket=true){
            let req = {
              personId:this.guest.id,
              locationId:this.location.id
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'AccountByGuest')
            //handle response
         
            if(response.Successful){
              this.guestAccounts = response.AccountList
              this.guest.code=response.Guest.Code
              this.guest.messageString = response.Guest.messageString
              this.guest.alertString = response.Guest.alertString
              this.guest.isStudent=response.Guest.isStudent
              this.guest.EmailAddress=response.Guest.EmailAddress
              this.guest.PhoneNumber=response.Guest.PhoneNumber
              this.panels[0].title = this.panels[0].title 
              this.panels[0].subtitle1= this.guest.code 
              if(window.SHOW_FINANCIALAID==false || this.guest.messageString!=null){
                this.panels[0].subtitle2=  this.guest.messageString
              }
              
              this.panels[0].subtitle3=response.Guest.alertString
      
              if(response.Guest.loyaltyBalance >0 && this.guest.id !=this.defaultGuestId){
                this.panels[0].subtitle4=String(response.Guest.loyaltyBalance) + ' loyalty points'
              }else{
                this.panels[0].subtitle4=null
              }
              
              this.panels[0].image = response.Guest.photoFileName
    
              //NOW add the ticket
              if(createticket){this.AddTicket();}
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
          async GetGuestFinancialAid(){
            //only if we are showing fa
            if(window.SHOW_FINANCIALAID==false){return}
    
            this.panels[0].subtitle2="Looking up Financial Aid..."
    
            let req = {
              personId:this.guest.id,
              locationId:this.location.id
            }
            //call api
            this.$store.dispatch('beforeAPI');
            
            var response = await this.callAPI(req,'financialaidbyguest')
            //handle response
            
            if(response.Successful){
              this.faBalance=Number(response.StringResponse)
             
              if(this.faBalance<=0){
                this.panels[0].subtitle2="NO Financial Aid Available"
                this.faBalance=0
              }else{
                this.panels[0].subtitle2="Financial Aid: $" + this.faBalance.toFixed(2)
              }
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
          },
    
          isSelected(g){
            return g.id==this.guest.id
          },
          refresh(lookupstring){
   
            if(lookupstring!=''){
              this.lookupString=lookupstring
            }
            this.lookupGuest()
          },
          
        async getGuest(){
            
            //call api
            this.pleaseWait=true
            var response = await this.callAPI(null,'lookupguest')
            //handle response
            if(response.Successful){
              return response.transactionList
            }else{
              this.message = response.Message
            }
            this.pleaseWait=false;
        },
      
        //suspend
        async suspendticket(inticket=null){
          var tickettosuspend = inticket
          if(tickettosuspend==null){tickettosuspend=this.ticket}
          console.log('inpay=true suspendticket')
          this.inPayment=true
          let req = {
              ticket:tickettosuspend
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'suspendticket')
            //handle response
        
            if(response.Successful){
              this.inPayment=false
              this.$store.dispatch('startOver');
              this.getsuspendedticketcount()
            }else{
              this.responseMessage = response.Message
            }
            this.inPayment=false
            this.pleaseWait=false;
        },
        async getsuspendedticketcount(){
          
          //this.inPayment=true
          let req = {
              businessDayId:this.businessDayId
          }
          //call api
          //this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'getsuspendedtickets')
          //handle response
      
          if(response.Successful){
         
              this.suspendedTicketCount=response.ticketList.length
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;
                  
      },


        removeticket(id){
          if(id==this.ticket.id){
            this.$store.dispatch('startOver');
          }
        },
        
        
        //tax exempt
        async taxexempt(isexempt=true){
    
          this.ticket.isTaxExempt=isexempt
          let req = {
              ticket:this.ticket
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'tickettaxexempt')
            //handle response
         
            if(response.Successful){
               this.refresh()
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },

        /* //process pmts
        async process(){
          if(this.addingProduct){return}
          console.log('inpay=true process-pos')
          this.inPayment=true
          let req = {
              ticket:this.ticket
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'processticketpayment')
            //handle response
         
            if(response.Successful){
               this.inPayment=false
               this.toNext()
               //this.toComplete()
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
            this.inPayment=false
        },
         */

        //money helper functions
        subtractmoney(m1, m2){
          var divide=true
          var m100=Math.round(m1 * 100)
          var m200=Math.round(m2 * 100)
          //if(String(m100).includes('.999')){m100=m1;m200=m2;divide=false}
          //if(String(m200).includes('.999')){m200=m2}
          var diff = Math.round(m100-m200)

          if(divide){
            return diff /100
          }else{
            return diff
          }
          
        },
        
        addmoney(m1, m2){
          var m100=Math.round(m1 * 100)
          var m200=Math.round(m2 * 100)
          var diff = m100+m200
          return diff /100
        },
        
    }

}

